module.exports = __webpack_public_path__ + "static/media/delete-notes.04a7dd4c.svg";